module.exports = __webpack_public_path__ + "static/media/house2.2291c4f5.png";